import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";
import { Icon } from "components";
import { useTranslate } from "hooks";

Scrivito.provideComponent("TextWidget", ({ widget }) => {
  const translate = useTranslate();
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const links = widget.get("links");
  const complementaryText = widget.get("complementaryText");

  const ContentWithoutLinks = Scrivito.connect(() => (
    <div>
      {isOpen && (
        <Scrivito.ContentTag
          content={widget}
          attribute="complementaryText"
          className="complementary-text"
        />
      )}
      {isOpen ? (
        <button className="button button-upload" onClick={toggle}>
          {translate("TEXT_LESS_TEXT")}
          <Icon iconName="circle-chevron-up" prefix="fa-regular" />
        </button>
      ) : (
        <button className="button button-download" onClick={toggle}>
          {translate("TEXT_MORE_TEXT")}
          <Icon iconName="circle-chevron-down" prefix="fa-regular" />
        </button>
      )}
    </div>
  ));

  const ContentWithLinks = Scrivito.connect(() => (
    <div>
      <Scrivito.ContentTag
        content={widget}
        attribute="complementaryText"
        className="complementary-text"
      />
      <p>
        {links.map((link, idx) => (
          <Scrivito.LinkTag
            key={idx}
            to={getPageLink(link)}
            className="button button-linklist"
          >
            {link.title()}
            <Icon prefix="fa-regular" iconName="circle-chevron-right" />
          </Scrivito.LinkTag>
        ))}
      </p>
    </div>
  ));

  return (
    <div className="text-widget mb-6">
      <Scrivito.ContentTag tag="h2" content={widget} attribute="title" />
      <Scrivito.ContentTag tag="div" content={widget} attribute="body" />
      {links.length === 0 && complementaryText && <ContentWithoutLinks />}
      {links.length > 0 && <ContentWithLinks />}
    </div>
  );
});
